import Rule from "../../../common/rule";

export default class SafetyFieldSetup extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return ruleContext.isSafety;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const spot = gameContext.gameConfig.spots.safetyYardline;

        let fieldPosition = !gameContext.homeTeamHasPossession
            ? gameContext.getFieldLength() - spot
            : spot;

        gameContext.setFieldPosition(fieldPosition);
        gameContext.setDriveContext({ triggerDrive: true });
    }
}
